module.exports = __webpack_public_path__ + "static/media/my-account-bg.2e1651a8.jpg";